import React, { useState, useEffect, useMemo, memo } from 'react';
import { ThemeProvider } from 'styled-components';
import { MuiThemeProvider } from '@material-ui/core/styles';

import { Intercom } from 'components/Intercom';
import NewCar from 'components/NewCar';
import { ActionButton as QualifierLeadButton } from 'modules/leadQualifier/components/ActionButton';
import NotificationsBeamer from 'components/NotificationsBeamer';
import UserProfile from 'components/UserProfile';
import MobiCopilot from 'modules/mobiCopilot';
import { MODULE_PRODUCT_NAME } from 'modules/mobiCopilot/utils/constants';
import useProduct from 'hooks/useProduct';
import { usePermissions } from 'hooks/usePermissions';

import { Notifications } from 'modules/notifications/components/Notifications';

import isEmpty from 'helpers/isEmpty';
import Dashboard from 'pages/dashBoard';
import { getThemes } from 'styles/global';

import MainContext from './MainContext';

const notifications = [NotificationsBeamer, Notifications];
const listHeader = [
  QualifierLeadButton,
  NewCar,
  Intercom,
  ...notifications,
  UserProfile,
];

const listHeaderWithCopilot = [
  QualifierLeadButton,
  NewCar,
  MobiCopilot,
  Intercom,
  ...notifications,
  UserProfile,
];

const PRIMARY_COLOR_DEFAULT = '#00B0AA';
const SECONDARY_COLOR_DEFAULT = '#444444';

const MainComponent = props => {
  const getPrimaryColor = useMemo(
    () =>
      !isEmpty(props.dealerStore?.primaryColor)
        ? props.dealerStore?.primaryColor
        : PRIMARY_COLOR_DEFAULT,
    [props.dealerStore?.primaryColor]
  );

  const getSecondaryColor = useMemo(
    () =>
      !isEmpty(props.dealerStore?.secondaryColor)
        ? props.dealerStore?.secondaryColor
        : SECONDARY_COLOR_DEFAULT,
    [props.dealerStore?.secondaryColor]
  );

  const { hasProduct } = useProduct();
  const { hasPermission } = usePermissions();
  const hasMobiCopilotProductAndPermission =
    hasProduct(MODULE_PRODUCT_NAME) && hasPermission('COPILOT');

  const [themes, setTheme] = useState(null);
  const [reRenderMenu, setReRenderMenu] = useState(true);
  const [colors, setColor] = useState({
    primaryColor: getPrimaryColor,
    secondaryColor: getSecondaryColor,
  });

  useEffect(() => {
    setReRenderMenu(false);
    setTheme(getThemes(colors?.primaryColor, colors?.secondaryColor));
    setTimeout(() => setReRenderMenu(true), 10);
  }, [colors.primaryColor, colors.secondaryColor]);

  useEffect(() => {
    setReRenderMenu(false);
    setColor({
      primaryColor: getPrimaryColor,
      secondaryColor: getSecondaryColor,
    });
    setTheme(getThemes(colors?.primaryColor, colors?.secondaryColor));
    setTimeout(() => setReRenderMenu(true), 10);
  }, [props.dealerStore?.primaryColor, props.dealerStore?.secondaryColor]);

  if (themes) {
    return (
      <ThemeProvider theme={themes.styledThemeColors}>
        <MuiThemeProvider theme={themes.materialThemeGlobal}>
          <MainContext.Provider value={{ colors, setColor }}>
            <Dashboard
              {...props}
              reRenderMenu={reRenderMenu}
              routes={props.routes}
              listHeader={
                hasMobiCopilotProductAndPermission
                  ? listHeaderWithCopilot
                  : listHeader
              }
              isWithoutDealer={props.isWithoutDealer}
              isInConsultantScreen={props.isInConsultantScreen}
              isConsultantUser={props.isConsultantUser}
            />
          </MainContext.Provider>
        </MuiThemeProvider>
      </ThemeProvider>
    );
  }
  return <div></div>;
};

export default memo(MainComponent);
